import { render, staticRenderFns } from "./TherapyHours.vue?vue&type=template&id=8fc88036&scoped=true&"
import script from "./TherapyHours.vue?vue&type=script&lang=js&"
export * from "./TherapyHours.vue?vue&type=script&lang=js&"
import style0 from "./TherapyHours.vue?vue&type=style&index=0&id=8fc88036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc88036",
  null
  
)

export default component.exports